// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fbb29834","977":"28a569bf"}[chunkId] + ".chunk.js";
};